import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function ValueStackSection() {
  const items = [{
    name: '7-3-1 Confirmation Calendar',
    value: '$15'
  }, {
    name: 'Day-7, Day-3, 24-Hour Checklists',
    value: '$12'
  }, {
    name: 'Moving Lines Tracker',
    value: '$8'
  }, {
    name: 'Copy-Paste Scripts (Email + Text)',
    value: '$7'
  }, {
    name: 'Plan B Options Guide',
    value: '$5'
  }];
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8
  }} className="py-16 lg:py-24 border-t border-[#1B6B3A]/10" data-id="element-163">
      <div className="max-w-xl mx-auto px-6" data-id="element-164">
        <h2 className="text-2xl lg:text-3xl font-serif font-bold text-[#1A1A1A] mb-8 text-center" data-id="element-165">
          What you're getting
        </h2>

        <div className="bg-white border border-[#1B6B3A]/10 rounded-lg p-6 lg:p-8 shadow-sm" data-id="element-166">
          <ul className="space-y-4 mb-6 border-b border-[#1B6B3A]/10 pb-6" data-id="element-167">
            {items.map((item, i) => <li key={i} className="flex items-center justify-between text-base lg:text-lg" data-id="element-168">
                <span className="text-[#3D3D3D]" data-id="element-169">{item.name}</span>
                <span className="text-[#6B6B6B] font-medium" data-id="element-170">{item.value}</span>
              </li>)}
          </ul>

          <div className="flex items-center justify-between text-lg lg:text-xl mb-2" data-id="element-171">
            <span className="text-[#6B6B6B]" data-id="element-172">Total Value</span>
            <span className="text-[#6B6B6B] line-through decoration-1" data-id="element-173">
              $47
            </span>
          </div>

          <div className="flex items-center justify-between text-xl lg:text-2xl font-bold" data-id="element-174">
            <span className="text-[#1A1A1A]" data-id="element-175">Your Price</span>
            <span className="text-[#1B6B3A]" data-id="element-176">$6.36</span>
          </div>
        </div>

        <a href="#pricing" onClick={e => {
        e.preventDefault();
        document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} className="group mt-6 w-full bg-[#1B6B3A] hover:bg-[#165930] text-white text-lg lg:text-xl font-bold py-4 px-8 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-[1.02] flex items-center justify-center gap-3" data-id="element-177">
          <span data-id="element-178">Get Closing Number Lock</span>
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-179" />
        </a>
      </div>
    </motion.section>;
}